import { updateField } from "vuex-map-fields";

const SET_BUTTONS_EXPANDED = (state, expanded) => {
  state.buttonsExpanded = expanded;
};
const SET_CUSTOMER_ID = (state, id) => {
  state.customerId = id;
};
const SET_FAMILY = (state, family) => {
  state.family = family;
};
const SET_ME = (state, me) => {
  state.me = me;
};
const SET_TASKS_COUNT = (state, count) => {
  state.tasksCount = count;
};
const SET_NOTES_COUNT = (state, count) => {
  state.notesCount = count;
};
const SET_FAMILY_LOADED = (state, loaded) => {
  state.familyLoaded = loaded;
};
const SET_SHOW_CREATE_NOTE_MODAL = (state, show) => {
  state.showCreateNoteModal = show;
};
const SET_SHOW_VIEW_NOTE_MODAL = (state, show) => {
  state.showViewNoteModal = show;
};
const SET_EDIT_NOTE_ID = (state, id) => {
  state.editNoteId = id;
};
const SET_VIEW_NOTE_ID = (state, id) => {
  state.viewNoteId = id;
};
const RESET_ATTACHABLES_COUNT = (state) => {
  state.notesCount = 0;
  state.tasksCount = 0;
};
export default {
  SET_SHOW_CREATE_NOTE_MODAL,
  SET_SHOW_VIEW_NOTE_MODAL,
  SET_EDIT_NOTE_ID,
  SET_VIEW_NOTE_ID,
  SET_FAMILY_LOADED,
  SET_FAMILY,
  SET_CUSTOMER_ID,
  SET_ME,
  SET_NOTES_COUNT,
  SET_TASKS_COUNT,
  SET_BUTTONS_EXPANDED,
  RESET_ATTACHABLES_COUNT,
  updateField,
};
